<template>
    <div class="header-bottom-container full-screen-container">
        <div class="header-bottom-bg flex-center" :style="{ backgroundImage: `url(${banner})` }">
            <div class="main-container flex-between content-container">
                <div class="left-container flex-start">
                    <img class="logo-img" :src="bandIndexLogo" alt="" v-if="bandIndexLogo" />
                    <div class="divider-line" v-if="bandIndexLogo && themeConfig.slogan"></div>
                    <img
                        class="slogn-img"
                        :src="themeConfig.slogan"
                        alt=""
                        v-if="themeConfig.slogan"
                    />
                </div>
                <!-- <div class="right-container flex-start">
                    <el-input
                        class="home-search-input"
                        v-model="searchVal"
                        clearable
                        placeholder="请输入搜索内容"/>
                        <el-button class="search-btn">搜索</el-button>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
    themeConfig: {
        type: Object,
        default: () => {
            return {};
        },
    },
});

const store = useStore();

let searchVal = ref('');

const showSlogan = computed(() => {
    // 只有西城品牌有
    return brand.value?.publishBrand?.brand == 'xcjyyxw';
});

// 全部备案信息
const brand = computed(() => {
    return store.state.brand || {};
});

// 首页导航Logo
const bandIndexLogo = computed(() => store.state.brand?.publishBrand?.brandConfig?.indexNavLogoUrl);

const banner = computed(() => {
    return props.themeConfig?.bannerUrl;
});
</script>

<style lang="scss" scoped>
.header-bottom-container {
    width: 100%;
    height: 160px;
    background: var(--home-header-bg);
    margin-top: 55px;
    &.gz-header-bottom-container {
        height: 100px;
        .header-bottom-bg {
            background-image: url(~@/assets/img/gateway/gz-top-bg.png);
        }
        .left-container .logo-img {
            height: 58px;
        }
    }
    &.xj-header-bottom-container {
        .header-bottom-bg {
            background-image: url(~@/assets/img/home/bg-xj.png);
        }
    }
    .header-bottom-bg {
        width: 1920px;
        position: relative;
        background-image: url(~@/assets/img/gateway/top-search-bg@2x.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .content-container {
        height: 100%;
        width: 1200px;
    }
    .left-container {
        .logo-img {
            // width: 321px;
            width: auto;
            height: 81px;
            img {
                width: auto;
                height: 81px;
                object-fit: contain !important;
            }
        }
        .slogn-img {
            max-width: 700px;
            height: 56px;
        }
        .divider-line {
            width: 2px;
            height: 60px;
            background: #cccccc;
            margin: 0 40px 0 44px;
        }
    }
    .right-container {
        .home-search-input {
            width: 260px;
            height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 16px;
            .el-input__wrapper {
                box-shadow: 0 0 0 1px #ffffff inset;
                border-radius: 4px 0 0 4px;
            }
        }
        .search-btn {
            width: 70px;
            height: 40px;
            background: linear-gradient(360deg, #228340 0%, #4ab02f 100%);
            border-radius: 0 4px 4px 0;
            color: #ffff;
            border: none;
        }
    }
}
</style>
